import { render, staticRenderFns } from "./MessageHighlight.vue?vue&type=template&id=f2aec34c"
import script from "./MessageHighlight.vue?vue&type=script&lang=js"
export * from "./MessageHighlight.vue?vue&type=script&lang=js"
import style0 from "./MessageHighlight.vue?vue&type=style&index=0&id=f2aec34c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports